export default __webpack_public_path__ + "static/media/product-owner2.3971bea2.png";